import { axios } from "../utils/axios";

const baseUrl = process.env.REACT_APP_API_HOST;
export const getTodoList = async (priority, limit, currentPage, inpval, region) => {
  try {
    const response = await fetch(
      `${baseUrl}/charts?priority=${priority}&page=${currentPage}&size=${limit}&column=${inpval.sort_column}&direction=${inpval.sort_direction}&client=${region.client}&location=${region.location}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        mode: "cors",
        body: JSON.stringify(inpval),
      },
    ).then((res) => res.json());
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBasicSearch = async (searchData) => {
  try {
    const response = await fetch(`${baseUrl}/global-search`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify(searchData),
    }).then((res) => res.json());
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getAdvancedSearch = async (obj) => {
  try {
    const response = await fetch(`${baseUrl}/global-search`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify(obj),
    }).then((res) => res.json());
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getMasterData = (clientId = null, locationId = null) => {
  try {
    const queryParams = new URLSearchParams();
    if (clientId) queryParams.append('client', clientId);
    if (locationId) queryParams.append('location', locationId);
    const queryString = "?" + queryParams.toString();
    return fetch(`${baseUrl}/hn-master-data${queryString}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
};

export const getActivityLogData = (id) => {
  try {
    return fetch(`${baseUrl}/charts/${id}/activity-log`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
};

export const addFilters = async (inpval) => {
  const response = await fetch(`${baseUrl}/charts/filter/data`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    mode: "cors",
    body: JSON.stringify(inpval),
  });

  return response;
};

export const getChartDetails = (id) => {
  try {
    return fetch(`${baseUrl}/charts/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
};

export const getChartAuditInfo = (id) => {
  try {
    return fetch(`${baseUrl}/charts/${id}/audit-info`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
};
export const saveChartInfo = (id, data, errors, clientData) => {
  try {
    return fetch(`${baseUrl}/charts/${id}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        const targetMessage = "chart_no must be unique";
        const messageExists = response?.error?.some(
          (obj) => obj.message === targetMessage,
        );
        if (clientData?.MilestoneId === 3) {
          if (response.success && response.message) {
            localStorage.setItem("isFormDirty", "false");
            window.toastr.success(
              "Chart details saved successfully. Please stop the timer.",
            );
            return true;
          } else {
            if (response.error) {
              let errors = response.error.map((key) => {
                return key.message ?? key.name;
              });
              window.toastr.options = {
                showDuration: "300",
                hideDuration: "1000",
                timeOut: 5000 + errors.length * 1000,
                extendedTimeOut: "1000",
                preventDuplicates: true,
              };
              messageExists
                ? window.toastr.error("Chart number already exists")
                : window.toastr.error(errors.join("<br>"));
              window.toastr.options = { preventDuplicates: true };
            } else {
              window.toastr.error(response.message ?? "Something went wrong!");
            }
          }
        }
      });
  } catch (error) {
    console.log(error);
  }
};

export const getTotalTime = (id) => {
  try {
    return fetch(`${baseUrl}/charts/${id}/total-time`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
};

export const saveChartAuditInfo = (id, data, clientData) => {
  try {
    return fetch(`${baseUrl}/charts/${id}/audit-info`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        if (clientData?.MilestoneId === 6) {
          if (response.success && response.message) {
            window.toastr.success(
              "Chart details saved successfully. Please stop the timer.",
            );
            return true;
          } else {
            if (response.error) {
              let errors = response.error.map((key) => {
                return key.message ?? key.name;
              });
              window.toastr.options = {
                showDuration: "300",
                hideDuration: "1000",
                timeOut: 5000 + errors.length * 1000,
                extendedTimeOut: "1000",
              };
              window.toastr.error(errors.join("<br>"));
              window.toastr.options = {};
            } else {
              window.toastr.error(response.message ?? "Something went wrong!");
            }
          }
        }
      });
  } catch (error) {
    console.log(error);
  }
};

export const deleteButton = async (dataForDeleteButton) => {
  try {
    await fetch(`${baseUrl}/users/configurations`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify(dataForDeleteButton),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.success && response.message) {
          window.toastr.success("Configuration deleted successfully.");
          return true;
        } else {
          if (response.error) {
            let errors = response.error.map((key) => {
              return key.message ?? key.name;
            });
            window.toastr.options = {
              showDuration: "300",
              hideDuration: "1000",
              timeOut: 5000 + errors.length * 1000,
              extendedTimeOut: "1000",
            };
            window.toastr.error(errors.join("<br>"));
            window.toastr.options = {};
          } else {
            window.toastr.error(response.message ?? "Something went wrong!");
          }
        }
      });
  } catch (error) {
    console.log(error);
  }
};

export const reallocateChartToAuditor = (data) => {
  try {
    return fetch(`${baseUrl}/worklists/reallocation-auditor`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
};

export const reallocateChartToCoder = (data) => {
  try {
    return fetch(`${baseUrl}/worklists/reallocation-coder`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
};

export const modifyCharts = (data) => {
  try {
    return fetch(`${baseUrl}/worklists/chart-modification`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
};
export const selfAllocation = (data) => {
  try {
    return fetch(`${baseUrl}/charts/self-allocation`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
};

export const doesChartNoExistInSystem = async (chartId, chartNo, region) => {
  let jsonData;
  try {
    let res = await axios.post(`${baseUrl}/charts/${chartId}/does-chart-exist`, {chart_no: chartNo, region});
    jsonData = res;
  } catch (e) {
    if (e?.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

export const getWatchlistNumber = async (data) => {
  let jsonData;
  try {
    let res = await axios.post(`${baseUrl}/charts/filters/autocomplete`, data);
    jsonData = res;
  } catch (e) {
    if (e?.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

export const deleteChart = async (data) => {
  let res;
  try {
    res = await axios.post(`${baseUrl}/charts/soft-delete`, data);
  } catch (e) {}
  return res;
};

export const addPriorities = async (data) => {
  const response = await fetch(`${baseUrl}/charts/priorities`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    mode: "cors",
    body: JSON.stringify(data),
  });

  return response;
};

export const deleteCharts = (chartIds) => {
  try {
    const idsParam = chartIds.ChartId.join(','); 

    const endpoint = `${baseUrl}/charts?ids=${idsParam}`;

    return fetch(endpoint, {
      method: "DELETE", 
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
};

export const updateNewAuditInfo = (data, chartId) => {
  try {
    return fetch(`${baseUrl}/v2/charts/${chartId}/audit-info`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
}

export const shareChartForReview = async (data, chartId) => {
  try {
    const res = await axios.post(`${baseUrl}/charts/${chartId}/share-for-review`, data);
    return res;
  } catch (e) {
    if (e?.response) {
      return e.response.data;
    } else {
      return {};
    }
  }
}
